import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AccessRightEnum } from '../../../../enum/AccessRightEnum';
import { IBundle } from '../../../../model/options/IBundle';
import { IParams } from '../../../../model/shared/IParams';
import { formatDate, hasAccessRights } from '../../../../shared/functions/Functions';
import { IAllStates } from '../../../../store/rootReducer';
import { ErrorToast, WarningToast } from '../../../../utils/toasters';
import OptionComments from './components/OptionComments';
import PartnerFeedbackCard from './components/PartnerFeedbackCard';
import PartnerFeedbackUpload from './components/PartnerFeedbackUpload';
import { OptionService } from './service';
import DiscoveryFavorites from '../discovery/favorites/DiscoveryFavorites';

export function CampaignOptions() {
    const { id } = useParams<keyof IParams>();
    const { t } = useTranslation();
    const [bundle, setBundle] = useState<IBundle | undefined>(undefined);
    const [triggerUpdate, setTriggerUpdate] = useState(false);
    const { accessRights } = useSelector((state: IAllStates) => state.auth.user);
    const canCreateOption = accessRights.includes(AccessRightEnum.CAN_CREATE_OPTIONS);
    const lastMessageRef = useRef<HTMLElement>(null);
    const [newMessage, setNewMessage] = useState<string>('');
    const [isSendDisabled, setIsSendDisabled] = useState(false);

    useEffect(() => {
        if (!!id) {
            OptionService.getBundle(id, true)
                .then(response => {
                    if (response.id) {
                        setBundle({
                            ...response,
                            feedback: !!bundle?.feedback ? bundle.feedback : response.feedback,
                            budget: !!bundle?.budget ? bundle.budget : response.budget,
                        });
                    }
                })
                .catch(err => ErrorToast(err));
        }
    }, [id, triggerUpdate]);

    useEffect(() => {
        if (bundle?.comments?.length && lastMessageRef?.current) {
            lastMessageRef?.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [bundle?.comments?.length, lastMessageRef?.current]);

    const sendMessageHandler = async () => {
        if (!newMessage?.length) {
            return WarningToast(t('general.toasts.warnEmptyMessage'));
        }
        setIsSendDisabled(true);
        await OptionService.sendComment(bundle?.id!, newMessage.replace(/\n/g, '</br>'))
            .then(response => {
                if (response === '') {
                    setNewMessage('');
                    setTriggerUpdate(prev => !prev);
                }
            })
            .catch(err => ErrorToast(err))
            .finally(() => setIsSendDisabled(false));
    };

    return (
        <div>
            {hasAccessRights(AccessRightEnum.CAN_VIEW_DISCOVERY_BUNDLE) && <DiscoveryFavorites />}

            {/* <Row>
                <Col md={6} className="mb-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <h4 className="mb-0">{t('brand.options.influencerOfferBundles')}</h4>
                        {bundle?.updatedAt && (
                            <span className="text-muted">Updated at: {formatDate(bundle?.updatedAt)}</span>
                        )}
                    </div>
                </Col>
                <Col md={6} />
                <Col md={6}>
                    {canCreateOption ? (
                        <PartnerFeedbackUpload
                            bundle={bundle as IBundle}
                            setTriggerUpdate={setTriggerUpdate}
                            setBundle={setBundle as React.Dispatch<SetStateAction<IBundle>>}
                        />
                    ) : (
                        <PartnerFeedbackCard bundle={bundle as IBundle} />
                    )}
                </Col>
                <Col md={6} className="mt-md-0 mt-3">
                    <OptionComments
                        sendMessageHandler={sendMessageHandler}
                        bundle={bundle as IBundle}
                        setNewMessage={setNewMessage}
                        newMessage={newMessage}
                        isSendDisabled={isSendDisabled}
                        lastMessageRef={lastMessageRef}
                    />
                </Col>
            </Row> */}
        </div>
    );
}
